// Crisis Messaging
var crisisMessage = jq(".crisis-messaging");
var crisisMessageCookieName = "eqMajorAnnouncement";
if (crisisMessage.length) {
    jq('.crisis-messaging a[href="#"]').click(function (e){
        e.preventDefault();
        crisisMessage.addClass("hide");
    });
    var crisisMessageTimestamp = crisisMessage.data("timestamp");
    console.log(crisisMessageTimestamp);
    var crisisMessageCookie = Cookies.get(crisisMessageCookieName);
    if (crisisMessageCookie != crisisMessageTimestamp) {
        crisisMessage.removeClass("hide");
        // Expires should be set to a number of days
        Cookies.set(crisisMessageCookieName, crisisMessageTimestamp, {secure: true, domain: window.location.hostname, expires: 7 });
    }
}